module.exports = "iframe{\n  padding-bottom: 2em;\n}\n"